import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {Subscription} from 'rxjs';
import {BonusService} from '../../bonus.service';
import {Constants} from '../../../../shared/utils/constants';
import {AppService} from '../../../../app.service';
import { PromotionProps } from '../promotion-bonus.type';

@Component({
  selector: 'fx-bonus-network',
  templateUrl: './bonus-network.component.html',
  styleUrls: ['./bonus-network.component.sass'],
})
export class BonusNetworkComponent implements OnInit, OnChanges {
  @Input() bonus: PromotionProps;
  @Output() stateChanged = new EventEmitter<void>();
  data: any = [];
  subscription: Subscription;
  selectedItem: any;
  targetEvent = null;
  constructor(private service: BonusService, private appService: AppService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bonus && this.bonus) {
      if (Object.keys(this.bonus).length <= 0) {
        return;
      }
      this.targetEvent = this.bonus.mt5_bonus_event_id;
      this.data = [
        {
          root: true,
          user_id: this.bonus.user_id,
          email: this.bonus.email,
          expanded: true,
          mode: this.bonus.mode,
          children: [],
        },
      ];
      this.getData(this.data[0], true);
    }
  }

  getData(item: any, first = false): void {
    const option = {
      user_id: item.user_id,
      mt5_bonus_event_id: this.targetEvent
    }
    this.service.getEventChildren(option).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        item.children = res.data;
        this.data = this.buildTree(res.data, item);
      }
    });
  }

  buildTree(data: any, root: any): any {
    const map = {};
    let node: any;
    const roots: any[] = [];
    data.forEach((item: any, i: number) => {
      item.ib = true;
      map[item.user_id] = i;
      item.children = [
        ...(item.children || []),
        ...(item.traders || []).map((trader: string) => {
          return { ib: false, email: trader };
        }),
      ];
    });
    data.forEach((item: any, i: number) => {
      node = item;
      if (node.parent_id || node.parent_id === 0) {
        if (data[map[node.parent_id]]) {
          data[map[node.parent_id]].children.push(node);
        }
      }
      if (node.user_id === root.user_id) {
        roots.push(node);
      }
    });
    return roots;
  }

  onExpanded(node: any): void {
    if (node) {
      this.getData(node);
    }
  }
  onModed(event): void {
    this.updateModeEvent(event);
  }

  onSelectItem(node: any): void {
    this.selectedItem = node;
  }

  updateModeEvent(node: any): void {
    const body = {
      mt5_bonus_event_id: this.targetEvent,
      user_id: node.user_id,
      mode: !node.mode ? 0 : 1
    };
    this.service.updateModeEvents(body).subscribe(res => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Update mode event success');
        this.getData(this.data[0]);
        this.stateChanged.emit();
      }
    });
  }

  ngOnInit(): void {}
}
